import { AuthController } from './auth.controller';

export const AUTH_CONTROLLERS = [AuthController];
